import {
    RequestedCreateEquipmentSetActionCreator,
    SuccceededCreateEquipmentSetActionCreator,
    FailedCreateEquipmentSetActionCreator,
    RequestedUpdateEquipmentSetActionCreator,
    SuccceededUpdateEquipmentSetActionCreator,
    FailedUpdateEquipmentSetActionCreator,
    SetEquipmentSetsActionCreator,
    SetEquipmentSetActionCreator,
    SuccceededDeleteEquipmentSetActionCreator,
    FailedDeleteEquipmentSetActionCreator,
    RequestedDeleteEquipmentSetActionCreator
} from './types';
import {
    EQUIPMENT_SET_CREATE_REQUESTED,
    EQUIPMENT_SET_CREATE_SUCCEEDED,
    EQUIPMENT_SET_CREATE_FAILED,
    EQUIPMENT_SET_UPDATE_REQUESTED,
    EQUIPMENT_SET_UPDATE_SUCCEEDED,
    EQUIPMENT_SET_UPDATE_FAILED,
    EQUIPMENT_SETS_SET,
    EQUIPMENT_SET_SET,
    EQUIPMENT_SET_DELETE_REQUESTED,
    EQUIPMENT_SET_DELETE_SUCCEEDED,
    EQUIPMENT_SET_DELETE_FAILED
} from './constants';

export const requestedCreateEquipmentSet: RequestedCreateEquipmentSetActionCreator = (
    equipmentSet
) => {
    return {
        type: EQUIPMENT_SET_CREATE_REQUESTED,
        payload: equipmentSet
    };
};

export const succeededCreateEquipmentSet: SuccceededCreateEquipmentSetActionCreator = (
    response
) => {
    return {
        type: EQUIPMENT_SET_CREATE_SUCCEEDED,
        payload: response
    };
};

export const failedCreateEquipmentSet: FailedCreateEquipmentSetActionCreator = (
    error
) => {
    return {
        type: EQUIPMENT_SET_CREATE_FAILED,
        payload: error,
        error: true
    };
};

export const requestedUpdateEquipmentSet: RequestedUpdateEquipmentSetActionCreator = (
    equipmentSetId,
    equipmentSet
) => {
    return {
        type: EQUIPMENT_SET_UPDATE_REQUESTED,
        payload: {
            equipmentSetId,
            equipmentSet
        }
    };
};

export const succeededUpdateEquipmentSet: SuccceededUpdateEquipmentSetActionCreator = (
    response
) => {
    return {
        type: EQUIPMENT_SET_UPDATE_SUCCEEDED,
        payload: response
    };
};

export const failedUpdateEquipmentSet: FailedUpdateEquipmentSetActionCreator = (
    error
) => {
    return {
        type: EQUIPMENT_SET_UPDATE_FAILED,
        payload: error,
        error: true
    };
};

export const setEquipmentSets: SetEquipmentSetsActionCreator = (
    equipmentSetsKeyedById
) => {
    return {
        type: EQUIPMENT_SETS_SET,
        payload: equipmentSetsKeyedById
    };
};

export const setEquipmentSet: SetEquipmentSetActionCreator = (
    equipmentSetId,
    equipmentSet
) => {
    return {
        type: EQUIPMENT_SET_SET,
        payload: {
            equipmentSetId,
            equipmentSet
        }
    };
};

export const requestedDeleteEquipmentSet: RequestedDeleteEquipmentSetActionCreator = (
    equipmentSetId
) => {
    return {
        type: EQUIPMENT_SET_DELETE_REQUESTED,
        payload: {
            equipmentSetId
        }
    };
};

export const succeededDeleteEquipmentSet: SuccceededDeleteEquipmentSetActionCreator = (
    equipmentSetId
) => {
    return {
        type: EQUIPMENT_SET_DELETE_SUCCEEDED,
        payload: {
            equipmentSetId
        }
    };
};

export const failedDeleteEquipmentSet: FailedDeleteEquipmentSetActionCreator = (
    error
) => {
    return {
        type: EQUIPMENT_SET_DELETE_FAILED,
        payload: error,
        error: true
    };
};
